import React from 'react';
import GettingStarted from './workflows/GettingStarted';
import UserManagement from './workflows/UserManagement';
import DocumentIngestion from './workflows/DocumentIngestion';
import SOPGenerationWorkflow from './workflows/SOPGenerationWorkflow';
import SOPRefinementWorkflow from './workflows/SOPRefinementWorkflow';
import CorpusMapWorkflow from './workflows/CorpusMapWorkflow';

const CommonWorkflows = ({ activeWorkflow }) => {
  return (
    <section className="section">
      {(!activeWorkflow || activeWorkflow === 'getting-started') && <GettingStarted />}
      {activeWorkflow === 'user-management' && <UserManagement />}
      {activeWorkflow === 'document-ingestion' && <DocumentIngestion />}
      {(activeWorkflow === 'knowledge-graph' || activeWorkflow === 'corpus-map') && <CorpusMapWorkflow />}
      {activeWorkflow === 'sop-generation' && <SOPGenerationWorkflow />}
      {activeWorkflow === 'sop-refinement' && <SOPRefinementWorkflow />}
    </section>
  );
};

export default CommonWorkflows;
